import { render, staticRenderFns } from "./SLPA.vue?vue&type=template&id=6d1ebcf2&"
import script from "./SLPA.vue?vue&type=script&lang=ts&"
export * from "./SLPA.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports